<!--
    描述：专家预约记录详情
    日期：2021/01/20
    作者：zwh
-->
<template>
	<div class="Apage operation-layout">
		<div>
			<div class="search top-area">
				<el-row>
					<div class="operation-header">
						<div class="title">
							抽取信息
						</div>
					</div>
				</el-row>
				<div>
					<el-row>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">预约流水号：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.serialNo == '' ? '--' : objectItem.serialNo
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">抽取来源：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">
							{{ objectItem.sysName == '' ? '--' : objectItem.sysName }}
							<!-- <span v-if="objectItem.sysCode==''">--</span>
							<span v-if="objectItem.sysCode=='1001'">能工社运营管理平台</span>
							<span v-if="objectItem.sysCode=='1002'">能工社公共交易平台</span>
							<span v-if="objectItem.sysCode=='1003'">安招采业务系统</span>
							<span v-if="objectItem.sysCode=='1004'">专家评审项目</span>
							<span v-if="objectItem.sysCode=='1005'">资源价格系统</span>
							<span v-if="objectItem.sysCode=='1009'">专家通业务系统</span> -->
						</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">预约状态：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">
							<span style="color:red;font-weight:bold;font-size:16px;" v-if="objectItem.extractState === 1">未完成</span>
							<span style="color:blue;font-weight:bold;font-size:16px;" v-if="objectItem.extractState === 2">部分完成</span>
							<span style="color:#3B9A00;font-weight:bold;font-size:16px;" v-if="objectItem.extractState === 3">全部完成</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">预约人：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.userSname == '' ? '--' : objectItem.userSname
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">预约单位：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.companyName == '' ? '--' : objectItem.companyName
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">适用事项：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.applyItems == '' ? '--' : objectItem.applyItems
						}}</el-col>
					</el-row>
					<el-row>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">项目名称：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.projectName == '' ? '--' : objectItem.projectName
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">评标/评审时间：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.useStartTime == '' ? '--' : objectItem.useStartTime
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">结束时间：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.useEndTime == '' ? '--' : objectItem.useEndTime
						}}</el-col>
					</el-row>
					<el-row>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">评标/评审地址：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.reviewAdd == '' ? '--' : objectItem.reviewAdd
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">详细地址：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.detailAdd == '' ? '--' : objectItem.detailAdd
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">评标地点：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.evaluateAdd == '' ? '--' : objectItem.evaluateAdd
						}}</el-col>
					</el-row>
					<el-row>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">抽取总人数：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{
							objectItem.persons == '' ? '--' : objectItem.persons
						}}</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">抽取方式：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">
							{{
								objectItem.extractType == ''
									? '--'
									: objectItem.extractType == 1
									? '随机抽取'
									: objectItem.extractType == 2
									? '指定抽取'
									: '--'
							}}
						</el-col>
						<el-col class="text-overflow" :xl="2" :md="3" :span="3">业务编号：</el-col>
						<el-col class="text-overflow-text" :xl="4" :md="5" :span="5">{{ objectItem.busId == '' ? '--' : objectItem.busId }}</el-col>
					</el-row>
				</div>
			</div>

			<el-dialog :visible="ruleDialog.show" width="800px" center title="抽取规则" @close="ruleDialogClose">
				<el-form label-width="90px" :model="ruleDialog.ruleObjectItem" ref="ruleDialog">
					<el-row>
						<el-col :span="12">
							<el-form-item label="规避单位：" prop="status"> </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="规避专家：" prop="status"> </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="职称：" prop="status"> </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="职称专业：" prop="status"> </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="执业资格：" prop="status"> </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="登记专业：" prop="status"> </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="评标专业：" prop="status"> </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="评标区域：" prop="status"> </el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<div style="text-align: center">
					<el-button class="btn cancel-btn" size="small" @click="ruleDialogClose">取消</el-button>
				</div>
			</el-dialog>
		</div>

		<div class="operation-main">
			<div class="operation-header">
				<div class="title">
					抽取专家
				</div>
			</div>
		</div>
		<div class="operation-container w-table-layout w-table-page">
			<div class="w-table-content">
				<el-table ref="xTable" :data="tableObj.data" highlight-current-row height="100%" border>
					<el-table-column
						prop="expertName"
						label="专家姓名"
						header-align="center"
						align="left"
						show-overflow-tooltip
						width="100"
					></el-table-column>
					<el-table-column prop="randomCode" label="随机码" align="center" width="100"></el-table-column>
					<el-table-column prop="expertIdCard" label="身份证号" align="center" width="180"></el-table-column>
					<el-table-column prop="expertPhone" label="手机号码" show-overflow-tooltip align="center" width="120"></el-table-column>
					<el-table-column prop="noticeType" label="预约方式" align="center" show-overflow-tooltip width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.noticeType == 1">短信通知</span>
							<span v-if="scope.row.noticeType == 2">语音通知</span>
							<span v-if="scope.row.noticeType == 4">自主电话联系</span>
						</template>
					</el-table-column>
					<el-table-column prop="createDate" label="发送时间" align="center" width="160"></el-table-column>
					<el-table-column prop="noticeCount" label="次数" show-overflow-tooltip header-align="center" align="right" width="80">
						<template slot-scope="scope"> {{ scope.row.noticeCount }}次 </template>
					</el-table-column>
					<el-table-column prop="noticeInfo" label="内容" align="center" width="65" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.noticeType === 1">{{ scope.row.noticeInfo }}</span>
							<el-tooltip v-if="scope.row.noticeType === 2" class="item" effect="dark" placement="top-start">
								<div slot="content" v-html="toBreak(scope.row.noticeInfo, 'noticeInfo')"></div>
								<i v-if="scope.row.isPlay === 1" class="el-icon-video-pause" style="color:#409EFF;font-size:22px;"></i>
								<i
									v-else
									@click="voicePlay(scope.row, scope.$index)"
									class="el-icon-video-play"
									style="color:#409EFF;font-size:22px;cursor:pointer"
								></i>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="combRuleName" label="抽取规则" align="center" show-overflow-tooltip min-width="120">
						<!--
						<template slot-scope="scope">
							<el-button type="text"
									   @click="ruleDialogShow(scope.row)">抽取规则</el-button>
						</template>
						-->
					</el-table-column>
					<el-table-column prop="replyType" label="回复方式" align="center" show-overflow-tooltip min-width="120">
						<template slot-scope="scope">
							<span>{{ scope.row.replyType == '2' ? '语音回复' : scope.row.replyType == '3' ? '主动申请' : '' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="replyState" label="状态" align="center" width="110" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.replyState == 0">未回复</span>
							<span v-if="scope.row.replyState == 1" style="color: #1AA235;">参加</span>
							<span v-if="scope.row.replyState == 2" style="color: #ff0000;">不参加</span>
							<span v-if="scope.row.replyState == 3" style="color: #FF9E1B;">回复超时</span>
							<span v-if="scope.row.replyState == 4" style="color: #FF9E1B;">人数已满</span>
							<span v-if="scope.row.replyState == 9" style="color: #FF9E1B;">抽取超时</span>
							<span v-if="scope.row.replyState == 5" style="color: #ff0000;">不参加</span>
							<span v-if="scope.row.replyState == 6" style="color: #FF9E1B;">已评审</span>
							<span v-if="scope.row.replyState == 7" style="color: #FF9E1B;">已终止</span>
						</template>
					</el-table-column>
					<el-table-column label="备注" align="center" min-width="120">
						<template slot-scope="scope">
							<!-- -->
							<el-button type="text" @click="getRemark(scope.row)"  v-if="scope.row.replyType == '3' && scope.row.replyState == 5"
								>查看原因</el-button
							>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="table-footer w-table-footer" style="text-align:center;margin-top:5px;">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="tableObj.currentPage"
					:page-sizes="tableObj.pageList"
					:page-size="tableObj.pageSize"
					:total="tableObj.total"
					layout="total, sizes, prev, pager, next, jumper"
				>
				</el-pagination>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" width="600px" title="查看原因" destroy-on-close center>
			<div>请假原因：{{leaveTypeName}}</div>
			<div class="mt20">请假理由：{{leaveRemark}}</div>
		</el-dialog>
	</div>
</template>
<script>
import {
	getExpertsRecordsReplyDetailNew,
	getExpertsReplyPageListNew,
	getRuleInfoByRuleId,
} from "api/modules/expertsRecordsReply";

export default {
	name: '',
	components: {},
	props: {},
	data() {
		return {
			loading: false,
			objectItem: {},
			tableObj: {
				data: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},
			ruleDialog: {
				show: false,
				ruleObjectItem: {}
			},
			dialogVisible: false,
			leaveTypeName: '',
			leaveRemark: ''
		}
	},
	mounted() {},
	computed: {
		applyId() {
			return this.$route.query.id
		}
	},
	watch: {},
	created() {
		this.getDetailInfo()
		this.getDetailExpertInfo()
	},
	methods: {
		getDetailInfo() {
			let param = {
				id: this.applyId
			}
			getExpertsRecordsReplyDetailNew(param)
				.then((res) => {
					// console.log(res.data)
					this.objectItem = res.data
				})
				.catch((err) => {
					this.loading = false
				})
		},
		getDetailExpertInfo() {
			let that = this
			let param = {
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize,
				applyId: this.applyId
			}
			getExpertsReplyPageListNew(param)
				.then((res) => {
					// console.log(res.data)
					this.tableObj.data = res.data.records
					this.tableObj.currentPage = parseInt(res.data.current)
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.pageSize = parseInt(res.data.size)
				})
				.catch((err) => {
					this.loading = false
				})
		},
		ruleDialogShow(row) {
			this.ruleDialog.show = true
			this.ruleDialog.ruleObjectItem = {}
			if (!row.ruleId) return
			this.getRuleInfo()
		},
		getRuleInfo(row) {
			let that = this
			let param = {
				id: row.ruleId
			}
			getRuleInfoByRuleId(param)
				.then((res) => {
					this.ruleDialog.ruleObjectItem = res.data
				})
				.catch((err) => {})
		},
		voicePlay(row, index) {
			let that = this
			console.info(index)
			var msg = new SpeechSynthesisUtterance()
			msg.rate = 0.8 //播放语速
			msg.pitch = 1 //音调高低
			msg.text = row.noticeInfo
			msg.volume = 10 //播放音量
			msg.lang = 'zh-CN' //语言类型
			speechSynthesis.speak(msg) //播放
			msg.onstart = function() {
				console.log('开始播放会调用我')
				row.isPlay = 1
				console.log(that.tableObj.data)
				that.$set(that.tableObj.data, index, row)
			}
			msg.onend = function() {
				console.log('播放完成才会调用我')
				row.isPlay = 0
				that.$set(that.tableObj.data, index, row)
			}
			msg.onpause = function() {
				console.log('播放暂停才会调用我')
			}
			msg.onresume = function() {
				console.log('播放重新开始才会调用我')
			}
			msg.onerror = function(error) {
				that.$message({
					message: '请插入扬声器或耳机、或检查声卡',
					type: 'warning'
				})
				console.log('播放出现错误才会调用我' + error)
				row.isPlay = 0
				that.$set(that.tableObj.data, index, row)
			}
		},
		toBreak(txt, type) {
			if (type == 'noticeInfo') {
				if (txt.length > 66) return txt.match(/.{1,50}/g).join('<br />')
				else return txt
			}
		},
		ruleDialogClose() {
			this.ruleDialog.show = false
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getDetailExpertInfo()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.tableObj.currentPage = val
			this.getDetailExpertInfo()
		},
		// 返回
		goBack() {
			this.$router.push({ path: '/experts-records-reply-new' })
		},
		//查看不参加原因
		getRemark(item) {
			this.dialogVisible = true
			this.leaveTypeName = item.leaveTypeName || '-'
			this.leaveRemark = item.leaveRemark || '-'
		}
	}
}
</script>
<style lang="less">
.Apage {
	padding: 0 10px;
	.top-area {
		.text-overflow {
			text-align: right;
			color: #666;
			font-size: 14px;
			margin-bottom: 10px;
		}
		.text-overflow-text {
			color: #202020;
			font-size: 14px;
			margin-bottom: 10px;
		}
	}
}
</style>
